import packageInfo from '../../package.json';

export const environment = {
  production: true,
  version: packageInfo.version,
  configUrl: '/confighandler.ashx',
  testBaseUrl: '',
};
